import _asyncToGenerator from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/regenerator";
import { Keypair, sendAndConfirmTransaction, SystemProgram, Transaction } from '@solana/web3.js';
import { TOKEN_PROGRAM_ID } from '../constants.js';
import { createInitializeMint2Instruction } from '../instructions/initializeMint2.js';
import { getMinimumBalanceForRentExemptMint, MINT_SIZE } from '../state/mint.js';
/**
 * Create and initialize a new mint
 *
 * @param connection      Connection to use
 * @param payer           Payer of the transaction and initialization fees
 * @param mintAuthority   Account or multisig that will control minting
 * @param freezeAuthority Optional account or multisig that can freeze token accounts
 * @param decimals        Location of the decimal place
 * @param keypair         Optional keypair, defaulting to a new random one
 * @param confirmOptions  Options for confirming the transaction
 * @param programId       SPL Token program account
 *
 * @return Address of the new mint
 */

export function createMint(_x, _x2, _x3, _x4, _x5) {
  return _createMint.apply(this, arguments);
}

function _createMint() {
  _createMint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(connection, payer, mintAuthority, freezeAuthority, decimals) {
    var keypair,
        confirmOptions,
        programId,
        lamports,
        transaction,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            keypair = _args.length > 5 && _args[5] !== undefined ? _args[5] : Keypair.generate();
            confirmOptions = _args.length > 6 ? _args[6] : undefined;
            programId = _args.length > 7 && _args[7] !== undefined ? _args[7] : TOKEN_PROGRAM_ID;
            _context.next = 5;
            return getMinimumBalanceForRentExemptMint(connection);

          case 5:
            lamports = _context.sent;
            transaction = new Transaction().add(SystemProgram.createAccount({
              fromPubkey: payer.publicKey,
              newAccountPubkey: keypair.publicKey,
              space: MINT_SIZE,
              lamports: lamports,
              programId: programId
            }), createInitializeMint2Instruction(keypair.publicKey, decimals, mintAuthority, freezeAuthority, programId));
            _context.next = 9;
            return sendAndConfirmTransaction(connection, transaction, [payer, keypair], confirmOptions);

          case 9:
            return _context.abrupt("return", keypair.publicKey);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _createMint.apply(this, arguments);
}